export default __webpack_public_path__ + "66765a3bdcf9acd4b76ebe6576ef9475.jpg";